export default __webpack_public_path__ + "static/lightbox-a2ad92b434674371ec26fc4ba40961f1.jpg";